import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from "react-query/devtools";

/*import {legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import thunk from 'redux-thunk';
*/
import './index.css';
import App from './App';
import { Toaster } from 'react-hot-toast';
import { ContextProvider } from "./contexts/ContextProvider";

import "@fortawesome/fontawesome-free/css/all.min.css";

//const store = createStore(reducers, compose(applyMiddleware(thunk)));

const queryClient = new QueryClient(
    {
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            retry: 0,
          },
        },
      }
);

ReactDOM.render(
    <React.StrictMode>

        <QueryClientProvider client={queryClient}>
           {/*  <ReactQueryDevtools/> */}
            <ContextProvider>
             { /*  <Toaster  position="top-left" 
                      toastOptions={{
                        style: {
                          zIndex: 9999,
                        },
                      }}
                />*/}
                <Router>
                    <App />
                </Router>
            </ContextProvider>
        </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );

